/* 游民落地页 FAQ 的手风琴。
 *
 * 交互只有一条：点问题头展开或收起那一条，展开一条时先收起同一列表里已展开的那条（互斥）。
 * 展开态只切 is-open 类名与 aria-expanded，高度怎么变全在 CSS 里（grid-template-rows 0fr→1fr）。
 *
 * 监听挂在 document 上而不是逐个按钮上：主题编辑器每次重渲染这一节都会换掉整段 DOM，
 * 直接绑在元素上的监听会跟着一起没；委托写法对新 DOM 照样生效，也省掉一套重绑。
 */
(function () {
  'use strict';

  var QUESTION = '[data-starole-nomad-faq]';
  var ITEM = '.starole-nomad-landing__faq-item';
  var LIST = '.starole-nomad-landing__faq-list';

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var question = event.target.closest(QUESTION);
    if (!question) return;

    var item = question.closest(ITEM);
    var list = item && item.closest(LIST);
    /* 容器在 Liquid 里，脚本是单独的 asset：两边版本可能对不上（资源被缓存住），
       找不到容器就静默退出，这一节退回「点不开」的静态列表，别炸掉整页脚本。 */
    if (!list) return;

    var isOpen = item.classList.contains('is-open');

    var open = list.querySelectorAll(ITEM + '.is-open');
    for (var i = 0; i < open.length; i++) {
      open[i].classList.remove('is-open');
      var openQuestion = open[i].querySelector(QUESTION);
      if (openQuestion) openQuestion.setAttribute('aria-expanded', 'false');
    }

    /* 点已展开的那条等于收起：上面那轮已经把它收掉了，这里不用再做事。 */
    if (!isOpen) {
      item.classList.add('is-open');
      question.setAttribute('aria-expanded', 'true');
    }
  });
})();
